import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchUserTagData } from "@Actions/setUserTagData";
import { RootState } from "@Reducers/index";

function useUserCardData({ id }: any) {
  const userTagData = useSelector((state: RootState) => state.userTagData);
  const userData = userTagData[id]?.data || {};
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(fetchUserTagData(id));
    }
  }, [id]);
  return {
    userData,
  };
}

export default useUserCardData;
